import { ColorPicker } from "primereact/colorpicker";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useState } from "react";
import "react-quill/dist/quill.snow.css";
import Http from "../../../Common/Http";

const Create = ({ setVisible, fetchData }) => {
  const [inputs, setInputs] = useState({
    task_type: "",
    icon: "fa fa-tasks",
    color: "#3B82F6",
  });
  const [loading, setLoading] = useState(false);
  const [iconPreview, setIconPreview] = useState("fa fa-tasks");
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));

    // Update icon preview if icon input changes
    if (name === "icon") {
      setIconPreview(value);
    }
  };

  const handleColorChange = (e) => {
    const color = `#${e.value}`;
    setInputs((prev) => ({ ...prev, color }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // Ensure all fields have values
    const formData = {
      task_type: inputs.task_type.trim(),
      icon: inputs.icon.trim(),
      color: inputs.color.trim(),
    };

    try {
      const res = await Http.post(`/task-type/store`, formData);

      if (res.data) {
        setVisible(false);
        fetchData();
      }
    } catch (error) {
      setError("Failed to create task type. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // List of common Font Awesome icons for task types
  const commonIcons = [
    { name: "Tasks", icon: "fa fa-tasks" },
    { name: "Bug", icon: "fa fa-bug" },
    { name: "Feature", icon: "fa fa-star" },
    { name: "Epic", icon: "fa fa-bookmark" },
    { name: "Story", icon: "fa fa-book" },
    { name: "Issue", icon: "fa fa-exclamation-circle" },
    { name: "Enhancement", icon: "fa fa-wrench" },
    { name: "Note", icon: "fa fa-sticky-note" },
    { name: "Document", icon: "fa fa-file-text" },
  ];

  return (
    <div>
      {loading ? (
        <div className="text-center">
          <ProgressSpinner />
        </div>
      ) : (
        <div className="container">
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="row mb-3">
              <div className="col-lg-12">
                <label htmlFor="task_type" className="form-label">
                  Task Type Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="task_type"
                  id="task_type"
                  value={inputs.task_type}
                  onChange={handleInputChange}
                  placeholder="Enter task type (e.g., Bug, Story, Epic)"
                  required
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-lg-12">
                <label htmlFor="icon" className="form-label">
                  Icon Class (Font Awesome)
                </label>
                <div className="input-group">
                  <span className="input-group-text">
                    <i className={iconPreview} style={{ color: inputs.color }}></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    name="icon"
                    id="icon"
                    value={inputs.icon}
                    onChange={handleInputChange}
                    placeholder="e.g., fa fa-bug"
                  />
                </div>
                <small className="text-muted">Enter a Font Awesome icon class or choose from common icons below</small>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-lg-12">
                <label className="form-label d-block">Common Icons</label>
                <div className="d-flex flex-wrap gap-2">
                  {commonIcons.map((item) => (
                    <button
                      key={item.icon}
                      type="button"
                      className={`btn btn-sm ${inputs.icon === item.icon ? "btn-primary" : "btn-outline-secondary"}`}
                      onClick={() => {
                        setInputs((prev) => ({ ...prev, icon: item.icon }));
                        setIconPreview(item.icon);
                      }}
                    >
                      <i className={item.icon} style={{ marginRight: "5px" }}></i> {item.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-lg-12">
                <label htmlFor="color" className="form-label">
                  Color
                </label>
                <div className="d-flex align-items-center">
                  <div
                    className="color-preview mr-3"
                    style={{
                      width: "30px",
                      height: "30px",
                      backgroundColor: inputs.color,
                      borderRadius: "4px",
                      marginRight: "10px",
                      border: "1px solid #ddd",
                    }}
                  ></div>
                  <input
                    type="text"
                    className="form-control"
                    name="color"
                    value={inputs.color}
                    onChange={handleInputChange}
                    placeholder="Enter color code (e.g., #FF0000)"
                  />
                  <ColorPicker value={inputs.color.replace("#", "")} onChange={handleColorChange} className="ml-2" />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="preview-box p-3 mb-3" style={{ border: "1px solid #ddd", borderRadius: "4px" }}>
                  <h6>Preview:</h6>
                  <div className="d-flex align-items-center">
                    <span className="badge" style={{ backgroundColor: inputs.color, color: "#fff", padding: "8px 12px", borderRadius: "4px" }}>
                      <i className={inputs.icon} style={{ marginRight: "5px" }}></i>
                      {inputs.task_type || "Task Type"}
                    </span>
                  </div>
                </div>

                {/* <div className="mb-3">
                  <h6>Current Form Data:</h6>
                  <pre className="bg-light p-2" style={{ fontSize: "12px" }}>
                    {JSON.stringify(inputs, null, 2)}
                  </pre>
                </div> */}
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <button type="submit" className="btn btn-primary float-end">
                  Create Task Type
                </button>
                <button type="button" className="btn btn-secondary float-end me-2" onClick={() => setVisible(false)}>
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default Create;
